function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#google-calendar-deprecation_svg__filter0_d_5011_57744)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 37.922c0-.325.264-.589.589-.589h39.203c.325 0 .589.264.589.59v45.091a.589.589 0 01-.589.59H3.589a.589.589 0 01-.589-.59V37.922z",
  fill: "#7986CB"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M5.524 44.905h19.349v2.524H5.524zM5.524 40.698h29.444v2.524H5.524z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 93.446c0-.325.264-.589.589-.589h39.203c.325 0 .589.264.589.59v20.694a.589.589 0 01-.589.589H3.589a.589.589 0 01-.589-.589V93.446z",
  fill: "#32B679"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M5.524 100.428h19.349v2.524H5.524zM5.524 96.222h28.603v2.524H5.524z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.905 2.589c0-.325.264-.589.589-.589h39.203c.325 0 .589.264.589.589v80.425a.589.589 0 01-.59.59H46.495a.589.589 0 01-.59-.59V2.59z",
  fill: "#32B679"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M48.429 9.571h19.349v2.524H48.429zM48.429 5.365h28.603v2.524H48.429z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.905 102.7a.59.59 0 01.589-.589h39.203a.59.59 0 01.589.589v50.981a.59.59 0 01-.59.589H46.495a.59.59 0 01-.59-.589V102.7z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M48.429 108.841h19.349v2.524H48.429zM48.429 104.635h28.603v2.524H48.429z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.714 106.065a.59.59 0 01.589-.589h39.203c.326 0 .589.264.589.589v12.282a.588.588 0 01-.589.589h-39.203a.589.589 0 01-.589-.589v-12.282z",
  fill: "#32B679"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M134.238 113.048h19.349v2.524h-19.349zM134.238 108.841h28.603v2.524h-28.603z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.714 17.732a.59.59 0 01.589-.59h39.203c.326 0 .589.265.589.59v12.282a.588.588 0 01-.589.59h-39.203a.59.59 0 01-.589-.59V17.732z",
  fill: "#32B679"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M134.238 24.714h19.349v2.524h-19.349zM134.238 20.508h28.603v2.524h-28.603z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.714 123.732a.59.59 0 01.589-.589h39.203c.326 0 .589.264.589.589v12.282a.589.589 0 01-.589.589h-39.203a.59.59 0 01-.589-.589v-12.282z",
  fill: "#32B679"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M134.238 130.714h19.349v2.524h-19.349zM134.238 126.508h28.603v2.524h-28.603z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.81 102.7a.59.59 0 01.588-.589h39.204a.59.59 0 01.589.589v50.981a.59.59 0 01-.589.589H89.398a.59.59 0 01-.588-.589V102.7z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M91.334 108.841h19.349v2.524H91.334zM91.334 104.635h28.603v2.524H91.334z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.81 17.732c0-.325.263-.59.588-.59h39.204a.59.59 0 01.589.59v12.282a.59.59 0 01-.589.59H89.398a.589.589 0 01-.588-.59V17.732z",
  fill: "#32B679"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M91.334 24.714h19.349v2.524H91.334zM91.334 20.508h28.603v2.524H91.334z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.81 33.716c0-.325.263-.589.588-.589h39.204a.59.59 0 01.589.589v12.282a.59.59 0 01-.589.59H89.398a.589.589 0 01-.588-.59V33.716z",
  fill: "#E67C73"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M91.334 40.698h19.349v2.524H91.334zM91.334 36.492h28.603v2.524H91.334z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.81 71.573c0-.325.263-.589.588-.589h39.204a.59.59 0 01.589.59v12.282a.59.59 0 01-.589.588H89.398a.589.589 0 01-.588-.588V71.573z",
  fill: "#F6BF25"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M91.334 78.555h19.349v2.524H91.334zM91.334 74.349h28.603v2.524H91.334z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M174.619 2.589a.59.59 0 01.589-.589h39.203a.59.59 0 01.589.589v50.98a.59.59 0 01-.589.59h-39.203a.59.59 0 01-.589-.59V2.59z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M177.143 9.571h19.349v2.524h-19.349zM177.143 5.365h28.603v2.524h-28.603z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M174.619 114.478a.59.59 0 01.589-.589h39.203a.59.59 0 01.589.589v12.282a.589.589 0 01-.589.589h-39.203a.589.589 0 01-.589-.589v-12.282z",
  fill: "#E67C73"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M177.143 121.46h19.349v2.524h-19.349zM177.143 117.254h28.603v2.524h-28.603z"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "google-calendar-deprecation_svg__filter0_d_5011_57744",
  x: 0.476,
  y: 0.317,
  width: 217.048,
  height: 157.317,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.841
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.262
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5011_57744"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_5011_57744",
  result: "shape"
})));
function SvgGoogleCalendarDeprecation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 158,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgGoogleCalendarDeprecation;